<template>
  <div class="multi-sensor-table">
    <div
      v-if="rowData.length === 0"
      class="no-sensor-data-msg aisea-text-20-400-gray-black"
    >
      表示する情報が見つかりませんでした。
    </div>
    <table v-else>
      <thead class="table-header-group sticky-z1">
        <tr class="header-row-1 sticky-z1">
          <th :class="{ 'sticky-z1': !isMobileView }" colspan="2"></th>
          <template v-for="(columnDef, index) in columnDefs">
            <th
              class="header-sensor-name"
              colspan="2"
              :key="`header-sensor-name-${index}`"
            >
              {{ columnDef.sensorName }}
            </th>
          </template>
        </tr>
        <tr class="header-row-2">
          <th
            colspan="2"
            class="date-time"
            :class="{ 'sticky-z1': !isMobileView }"
          >
            日時
          </th>
          <template v-for="(columnDef, index) in columnDefs">
            <th
              class="sensor-column"
              v-for="(headerName, index) in columnDef.channelNames"
              :key="`${columnDef.channelIds[index]}`"
            >
              {{ headerName }}
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(date, index) in rowData" :key="index">
          <td
            colspan="2"
            class="p-2 date-time"
            :class="{ 'sticky-z0': !isMobileView }"
          >
            {{ date.datetimeJST }}
          </td>
          <template v-for="(sensor, index) in rowData[index].sensors">
            <td
              class="p-2 sensor-value"
              :key="`sensor-value-pressure-${index}`"
            >
              {{ sensor.pressure }}
            </td>
            <td
              class="p-2 sensor-value"
              :key="`sensor-value-temperature-${index}`"
            >
              {{ sensor.temperature }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("fuelConsumption");
export default {
  name: "MultiSensor",
  data() {
    return {
      isMobileView: false,
    };
  },
  computed: {
    ...mapState({
      columnDefs: state => state.sensorColumn,
      rowData: state => state.sensorRowsData,
    }),
  },
  methods: {
    handleResize() {
      this.isMobileView = window.innerWidth < 731;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.multi-sensor-table {
  overflow: auto;
  height: 460px;
  margin: 24px;
  position: relative;

  .no-sensor-data-msg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  table {
    border-spacing: 0;
    height: 60px;

    .sticky-z0 {
      position: sticky;
      top: 0;
      left: 0;
      background: #f2f2f2;
      z-index: 0;
    }

    .sticky-z1 {
      position: sticky;
      top: 0;
      left: 0;
      background: #626262;
      z-index: 1;
    }

    th,
    td {
      max-width: 250px;
      border-right: 1px solid #ababab;
      border-bottom: 1px solid #ababab;
      white-space: nowrap;
      font-size: 1rem;
    }

    tr:first-child th {
      border-top: 1px solid #ababab;
    }

    th:first-child {
      border-left: 1px solid #ababab;
    }

    td:first-child {
      border-left: 1px solid #ababab;
    }

    .header-row-1 {
      background: #626262;
      .header-sensor-name {
        text-align: center;
        color: #ffffff;
      }
    }

    .header-row-2 {
      text-align: center;
      background: #f2f2f2;
    }

    .date-time {
      text-align: center;
      background: #f2f2f2;
    }

    .sensor-column {
      text-align: center;
    }

    .sensor-value {
      text-align: center;
    }
  }
}

@media print {
  .multi-sensor-table {
    overflow: visible;
  }
}
</style>
